import React, { useState, useEffect } from "react";
import "./RelatedProducts.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FiHeart } from "react-icons/fi";
import { FaStar, FaStarHalfAlt, FaRegStar  } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { collection, query, where, orderBy, startAfter, limit, getDocs } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Link } from "react-router-dom";
const RelatedProducts = ({ product }) => {
  const [wishList, setWishList] = useState({});
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    if (!product?.category) return;

    const fetchRelatedProducts = async () => {
      try {
        const q = query(
          collection(db, "products"),
          where("category", "==", product.category),
          limit(12)
        );
        const querySnapshot = await getDocs(q);
        const products = querySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((item) => item.id !== product.productId);
        setRelatedProducts(products);
      } catch (error) {
        console.error("Error fetching related products:", error);
      }
    };

    fetchRelatedProducts();
  }, [product]);
  const handleWishlistClick = (productID) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="relatedProductSection">
        <div className="relatedProducts">
          <h2>
            RELATED <span>PRODUCTS</span>
          </h2>
        </div>
        <div className="relatedProductSlider">
          <div className="swiper-button image-swiper-button-next">
            <IoIosArrowForward />
          </div>
          <div className="swiper-button image-swiper-button-prev">
            <IoIosArrowBack />
          </div>
          <Swiper
            slidesPerView={4}
            slidesPerGroup={4}
            spaceBetween={30}
            loop={true}
            navigation={{
              nextEl: ".image-swiper-button-next",
              prevEl: ".image-swiper-button-prev",
            }}
            modules={[Navigation]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 14,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 30,
              },
            }}
          >
            {relatedProducts.map((product) => {
              return (
                <SwiperSlide key={product.productId}>
                  <div className="rpContainer">
                    <Link  to={`/product/${product.productId}`}
                      state={{ product }}  onClick={scrollToTop}>
                          <div className="rpImages" onClick={scrollToTop}>
                      <img
                        src={product.images[0]}
                        alt={product.title}
                        className="rpFrontImg"
                      />
                      <img
                        src={product.images[1]}
                        className="rpBackImg"
                        alt={product.title}
                      />
                      {/* <h4>Add to Cart</h4> */}
                    </div>
                      </Link>
                    <div className="relatedProductInfo">
                      <div className="rpCategoryWishlist">
                        <p>{product.category}</p>
                        <FiHeart
                          onClick={() => handleWishlistClick(product.productID)}
                          style={{
                            color: wishList[product.productID]
                              ? "red"
                              : "#767676",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className="productNameInfo">
                        <Link to={`/product/${product.productId}`}
                          state={{ product }} onClick={scrollToTop}>
                          <h5>{product.title}</h5>
                        </Link>
                        <p>
                          {product.hasDiscount ? (
                            <>
                              <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                                Rs.{product.price}
                              </span>
                              <span style={{ color: "black", }}>Rs.{product.discountPrice}</span>
                            </>
                          ) : (
                            <span>Rs.{product.price}</span>
                          )}
                        </p>
                        <div className="sdProductRatingReviews">
                          <div className="sdProductRatingStar">
                            {Array.from({ length: 5 }).map((_, index) => {
                              const rating = product.totalRating / product.totalPeopleReview; // Calculate average rating
                              const fullStars = Math.floor(rating);
                              const hasHalfStar = rating - fullStars >= 0.5;
                              if (index < fullStars) {
                                return <FaStar key={index} color="#FEC78A" size={14} />;
                              } else if (index === fullStars && hasHalfStar) {
                                return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                              } else {
                                return <FaRegStar key={index} color="#FEC78A" size={14} />;
                              }
                            })}
                          </div>
                          <span>{product.totalPeopleReview}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default RelatedProducts;
